import type { ComponentProps, ReactNode } from 'react'
import { useCallback, useMemo } from 'react'

import { Link } from 'react-router-dom'

import IconExternal from '@/assets/icons/icon-external.svg'
import { useMessageEditor } from '@/modules/message/components/editor/message-editor-context'
import type { PlaceholderVariant } from '@/modules/message/components/placeholder/variants'
import { classNames } from '@/utils/helpers'

export type Inserter = (variant: PlaceholderVariant) => void

export type AddMessageLabelsProps = Omit<ComponentProps<'div'>, 'children'> & {
  children: ({ insert }: { insert: Inserter }) => ReactNode
}

export const MessageLabelInserter = (props: AddMessageLabelsProps) => {
  const { children, className, ...rest } = props
  const { insert } = useMessageEditor()

  const handleInsert = useCallback(
    (variant: PlaceholderVariant) => {
      insert(variant)
    },
    [insert],
  )

  const labels = useMemo(
    () => children({ insert: handleInsert }),
    [children, handleInsert],
  )

  return (
    <div
      {...rest}
      className={classNames('flex flex-col gap-1.5', className)}
    >
      <label className="font-medium text-sm text-text-default flex items-center gap-2">
        Add Label
        <Link to="#">
          <IconExternal
            height={12.8}
            width={12.8}
            className="text-secondary-300"
          />
        </Link>
      </label>
      <div className="relative flex items-center flex-grow gap-3">{labels}</div>
    </div>
  )
}
